const TUI_BELARUSIAN_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Нумар', 'Нумар карты'],
  cardExpiry: ['Тэрмін', 'Тэрмін дзеяння']
};
const TUI_BELARUSIAN_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Колер', 'Градыент'],
  toolbarTools: {
    undo: 'Адрабіць',
    redo: 'Узнавіць',
    font: 'Шрыфт',
    fontStyle: 'Стыль шрыфту',
    fontSize: 'Памер шрыфту',
    bold: 'Тлусты',
    italic: 'Курсіў',
    underline: 'Падкрэслены',
    strikeThrough: 'Закрэслены',
    justify: 'Выраўноўванне',
    justifyLeft: 'Выраўнаваць па левым краі',
    justifyCenter: 'Выраўнаваць па цэнтры',
    justifyRight: 'Выраўнаваць па правым краі',
    justifyFull: 'Выраўнаваць па шырыні',
    list: 'Спіс',
    indent: 'Павялічыць водступ',
    outdent: 'Паменшыць водступ',
    unorderedList: 'Маркіраваны спіс',
    orderedList: 'Нумараваны спіс',
    quote: 'Цытата',
    foreColor: 'Колер тэксту',
    hiliteColor: 'Колер вылучэння',
    backColor: 'Колер фону',
    clear: 'Ачысціць фарматаванне',
    link: 'Спасылка',
    attach: 'Далучыць файл',
    tex: 'TeX',
    code: 'Код',
    image: 'Відарыс',
    insertHorizontalRule: 'Гарызантальная лінія',
    superscript: 'Надрадковы',
    subscript: 'Падрадковы',
    insertTable: 'Табліца',
    insertGroup: 'Група',
    hiliteGroup: 'Колер групы',
    removeGroup: 'Выдаліць групу',
    insertAnchor: 'Якар',
    mergeCells: 'Аб’яднаць ячэйкі',
    splitCells: 'Раз’яднаць ячэйкі',
    rowsColumnsManaging: 'Кіраванне радкамі і слупкамі',
    cellColor: 'Колер ячэйкі',
    setDetails: 'Акардэон',
    removeDetails: 'Выдаліць акардэон'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'Ідэнтыфікатар_якара'
  },
  editorTableCommands: [['Дадаць слупок злева', 'Дадаць слупок справа'], ['Дадаць радок зверху', 'Дадаць радок знізу'], ['Выдаліць слупок', 'Выдаліць радок']],
  editorCodeOptions: ['Inline-код', 'Блок кода'],
  editorFontOptions: {
    small: 'Малы',
    normal: 'Звычайны',
    large: 'Вялікі',
    title: 'Загаловак',
    subtitle: 'Падзагаловак'
  }
};
const TUI_BELARUSIAN_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Паказаць/Схаваць',
  paginationTexts: {
    pages: 'Старонак',
    linesPerPage: 'Радкоў на старонку',
    of: 'з'
  }
};
const TUI_BELARUSIAN_LANGUAGE_COUNTRIES = {
  AC: 'Востраў Узнясення',
  AD: 'Андора',
  AE: 'Аб’яднаныя Арабскія Эміраты',
  AF: 'Афганістан',
  AG: 'Антыгуа і Барбуда',
  AI: 'Ангілья',
  AL: 'Албанія',
  AM: 'Арменія',
  AO: 'Ангола',
  AR: 'Аргенціна',
  AS: 'Амерыканскае Самоа',
  AT: 'Аўстрыя',
  AU: 'Аўстралія',
  AW: 'Аруба',
  AX: 'Аландскія астравы',
  AZ: 'Азербайджан',
  BA: 'Боснія і Герцагавіна',
  BB: 'Барбадас',
  BD: 'Бангладэш',
  BE: 'Бельгія',
  BF: 'Буркіна-Фасо',
  BG: 'Балгарыя',
  BH: 'Бахрэйн',
  BI: 'Бурундзі',
  BJ: 'Бенін',
  BL: 'Сен-Бартэльмі',
  BM: 'Бермудскія астравы',
  BN: 'Бруней',
  BO: 'Балівія',
  BQ: 'Карыбскія Нідэрланды',
  BR: 'Бразілія',
  BS: 'Багамскія астравы',
  BT: 'Бутан',
  BW: 'Батсвана',
  BY: 'Беларусь',
  BZ: 'Беліз',
  CA: 'Канада',
  CC: 'Какосавыя (Кілінг) астравы',
  CD: 'Конга - Кіншаса',
  CF: 'Цэнтральна-Афрыканская Рэспубліка',
  CG: 'Конга - Бразавіль',
  CH: 'Швейцарыя',
  CI: 'Кот-д’Івуар',
  CK: 'Астравы Кука',
  CL: 'Чылі',
  CM: 'Камерун',
  CN: 'Кітай',
  CO: 'Калумбія',
  CR: 'Коста-Рыка',
  CU: 'Куба',
  CV: 'Каба-Вердэ',
  CW: 'Кюрасаа',
  CX: 'Востраў Раства',
  CY: 'Кіпр',
  CZ: 'Чэхія',
  DE: 'Германія',
  DJ: 'Джыбуці',
  DK: 'Данія',
  DM: 'Дамініка',
  DO: 'Дамініканская Рэспубліка',
  DZ: 'Алжыр',
  EC: 'Эквадор',
  EE: 'Эстонія',
  EG: 'Егіпет',
  EH: 'Заходняя Сахара',
  ER: 'Эрытрэя',
  ES: 'Іспанія',
  ET: 'Эфіопія',
  FI: 'Фінляндыя',
  FJ: 'Фіджы',
  FK: 'Фалклендскія астравы',
  FM: 'Федэратыўныя Штаты Мікранезіі',
  FO: 'Фарэрскія астравы',
  FR: 'Францыя',
  GA: 'Габон',
  GB: 'Вялікабрытанія',
  GD: 'Грэнада',
  GE: 'Грузія',
  GF: 'Французская Гвіяна',
  GG: 'Гернсі',
  GH: 'Гана',
  GI: 'Гібралтар',
  GL: 'Грэнландыя',
  GM: 'Гамбія',
  GN: 'Гвінея',
  GP: 'Гвадэлупа',
  GQ: 'Экватарыяльная Гвінея',
  GR: 'Грэцыя',
  GT: 'Гватэмала',
  GU: 'Гуам',
  GW: 'Гвінея-Бісау',
  GY: 'Гаяна',
  HK: 'Ганконг, САР (Кітай)',
  HN: 'Гандурас',
  HR: 'Харватыя',
  HT: 'Гаіці',
  HU: 'Венгрыя',
  ID: 'Інданезія',
  IE: 'Ірландыя',
  IL: 'Ізраіль',
  IM: 'Востраў Мэн',
  IN: 'Індыя',
  IO: 'Брытанская тэрыторыя ў Індыйскім акіяне',
  IQ: 'Ірак',
  IR: 'Іран',
  IS: 'Ісландыя',
  IT: 'Італія',
  JE: 'Джэрсі',
  JM: 'Ямайка',
  JO: 'Іарданія',
  JP: 'Японія',
  KE: 'Кенія',
  KG: 'Кыргызстан',
  KH: 'Камбоджа',
  KI: 'Кірыбаці',
  KM: 'Каморскія астравы',
  KN: 'Сент-Кітс і Невіс',
  KP: 'КНДР',
  KR: 'Рэспубліка Карэя',
  KW: 'Кувейт',
  KY: 'Кайманавы астравы',
  KZ: 'Казахстан',
  LA: 'Лаос',
  LB: 'Ліван',
  LC: 'Сент-Люсія',
  LI: 'Ліхтэнштэйн',
  LK: 'Шры-Ланка',
  LR: 'Ліберыя',
  LS: 'Лесота',
  LT: 'Літва',
  LU: 'Люксембург',
  LV: 'Латвія',
  LY: 'Лівія',
  MA: 'Марока',
  MC: 'Манака',
  MD: 'Малдова',
  ME: 'Чарнагорыя',
  MF: 'Сен-Мартэн',
  MG: 'Мадагаскар',
  MH: 'Маршалавы астравы',
  MK: 'Паўночная Македонія',
  ML: 'Малі',
  MM: 'М’янма (Бірма)',
  MN: 'Манголія',
  MO: 'Макаа, САР (Кітай)',
  MP: 'Паўночныя Марыянскія астравы',
  MQ: 'Марцініка',
  MR: 'Маўрытанія',
  MS: 'Мантсерат',
  MT: 'Мальта',
  MU: 'Маўрыкій',
  MV: 'Мальдывы',
  MW: 'Малаві',
  MX: 'Мексіка',
  MY: 'Малайзія',
  MZ: 'Мазамбік',
  NA: 'Намібія',
  NC: 'Новая Каледонія',
  NE: 'Нігер',
  NF: 'Востраў Норфалк',
  NG: 'Нігерыя',
  NI: 'Нікарагуа',
  NL: 'Нідэрланды',
  NO: 'Нарвегія',
  NP: 'Непал',
  NR: 'Науру',
  NU: 'Ніуэ',
  NZ: 'Новая Зеландыя',
  OM: 'Аман',
  PA: 'Панама',
  PE: 'Перу',
  PF: 'Французская Палінезія',
  PG: 'Папуа — Новая Гвінея',
  PH: 'Філіпіны',
  PK: 'Пакістан',
  PL: 'Польшча',
  PM: 'Сен-П’ер і Мікелон',
  PR: 'Пуэрта-Рыка',
  PS: 'Палесцінскія Тэрыторыі',
  PT: 'Партугалія',
  PW: 'Палау',
  PY: 'Парагвай',
  QA: 'Катар',
  RE: 'Рэюньён',
  RO: 'Румынія',
  RS: 'Сербія',
  RU: 'Расія',
  RW: 'Руанда',
  SA: 'Саудаўская Аравія',
  SB: 'Саламонавы астравы',
  SC: 'Сейшэльскія астравы',
  SD: 'Судан',
  SE: 'Швецыя',
  SG: 'Сінгапур',
  SH: 'Востраў Святой Алены',
  SI: 'Славенія',
  SJ: 'Шпіцберген і Ян-Маен',
  SK: 'Славакія',
  SL: 'Сьера-Леонэ',
  SM: 'Сан-Марына',
  SN: 'Сенегал',
  SO: 'Самалі',
  SR: 'Сурынам',
  SS: 'Паўднёвы Судан',
  ST: 'Сан-Тамэ і Прынсіпі',
  SV: 'Сальвадор',
  SX: 'Сінт-Мартэн',
  SY: 'Сірыя',
  SZ: 'Эсватыні',
  TA: 'Трыстан-да-Кунья',
  TC: 'Астравы Цёркс і Кайкас',
  TD: 'Чад',
  TG: 'Тога',
  TH: 'Тайланд',
  TJ: 'Таджыкістан',
  TK: 'Такелау',
  TL: 'Тымор-Лешці',
  TM: 'Туркменістан',
  TN: 'Туніс',
  TO: 'Тонга',
  TR: 'Турцыя',
  TT: 'Трынідад і Табага',
  TV: 'Тувалу',
  TW: 'Тайвань',
  TZ: 'Танзанія',
  UA: 'Украіна',
  UG: 'Уганда',
  US: 'Злучаныя Штаты Амерыкі',
  UY: 'Уругвай',
  UZ: 'Узбекістан',
  VA: 'Ватыкан',
  VC: 'Сент-Вінсент і Грэнадзіны',
  VE: 'Венесуэла',
  VG: 'Віргінскія астравы (Брыт.)',
  VI: 'Віргінскія астравы (Амер.)',
  VN: 'В’етнам',
  VU: 'Вануату',
  WF: 'Уоліс і Футуна',
  WS: 'Самоа',
  XK: 'Косава',
  YE: 'Емен',
  YT: 'Маёта',
  ZA: 'Паўднёва-Афрыканская Рэспубліка',
  ZM: 'Замбія',
  ZW: 'Зімбабвэ'
};
const TUI_BELARUSIAN_LANGUAGE_CORE = {
  months: ['Студзень', 'Люты', 'Сакавік', 'Красавік', 'Май', 'Чэрвень', 'Ліпень', 'Жнівень', 'Верасень', 'Кастрычнік', 'Лістапад', 'Снежань'],
  close: 'Закрыць',
  clear: 'Ачысціць',
  nothingFoundMessage: 'Нічога не знойдзена',
  defaultErrorMessage: 'Недапушчальнае значэнне',
  spinTexts: ['Папярэдні', 'Наступны'],
  shortWeekDays: ['Пн', 'Аў', 'Ср', 'Чц', 'Пт', 'Сб', 'Нд'],
  countries: TUI_BELARUSIAN_LANGUAGE_COUNTRIES
};
const TUI_BELARUSIAN_LANGUAGE_KIT = {
  cancel: 'Скасаваць',
  done: 'Гатова',
  more: 'Яшчэ',
  otherDate: 'Іншая дата...',
  showAll: 'Паказаць усё',
  hide: 'Схаваць',
  mobileCalendarTexts: ['Выберыце дату', 'Выберыце дыяпазон дат', 'Выберыце даты'],
  range: ['ад', 'да'],
  countTexts: ['Плюс', 'Мінус'],
  time: {
    'HH:MM': 'ГГ:ХХ',
    'HH:MM AA': 'ГГ:ХХ АА',
    'HH:MM:SS': 'ГГ:ХХ:СС',
    'HH:MM:SS AA': 'ГГ:ХХ:СС AA',
    'HH:MM:SS.MSS': 'ГГ:ХХ:СС.МСС',
    'HH:MM:SS.MSS AA': 'ГГ:ХХ:СС.МСС AA'
  },
  dateTexts: {
    DMY: 'дд.мм.гггг',
    MDY: 'мм.дд.гггг',
    YMD: 'гггг.мм.дд'
  },
  digitalInformationUnits: ['Б', 'КіБ', 'МіБ'],
  passwordTexts: ['Паказаць пароль', 'Схаваць пароль'],
  copyTexts: ['Капіяваць', 'Скапіявана'],
  shortCalendarMonths: ['Сту', 'Лют', 'Сак', 'Кра', 'Май', 'Чэр', 'Ліп', 'Жні', 'Вер', 'Кас', 'Ліс', 'Сне'],
  pagination: ['Папярэдняя старонка', 'Наступная старонка'],
  fileTexts: {
    loadingError: 'Памылка загрузкі',
    preview: 'Папярэдні прагляд',
    remove: 'Выдаліць'
  },
  inputFileTexts: {
    defaultLabelSingle: 'або перацягніце\u00A0яго\u00A0сюды',
    defaultLabelMultiple: 'або перацягніце\u00A0іх\u00A0сюды',
    defaultLinkSingle: 'Выберыце файл',
    defaultLinkMultiple: 'Выберыце файлы',
    maxSizeRejectionReason: 'Памер файла перавышае',
    formatRejectionReason: 'Няправільны тып файла',
    drop: 'Перацягніце файл сюды',
    dropMultiple: 'Перацягніце файлы сюды'
  },
  multiSelectTexts: {
    all: 'Выбраць усё',
    none: 'Зняць выбар'
  },
  confirm: {
    yes: 'Так',
    no: 'Не'
  },
  previewTexts: {
    rotate: 'Павярнуць'
  },
  zoomTexts: {
    zoomIn: 'Павялічыць',
    zoomOut: 'Паменшыць',
    reset: 'Скінуць маштаб'
  },
  phoneSearch: 'Увядзіце краіну або код'
};
const TUI_BELARUSIAN_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Папулярныя',
    history: 'Нядаўнія',
    placeholder: 'Увядзіце запыт',
    hotkey: 'для пошуку',
    all: 'Усе вынікі',
    empty: 'Нічога не знойдзена'
  }
};
const TUI_BELARUSIAN_LANGUAGE = {
  name: 'belarusian',
  ...TUI_BELARUSIAN_LANGUAGE_CORE,
  ...TUI_BELARUSIAN_LANGUAGE_KIT,
  ...TUI_BELARUSIAN_LANGUAGE_ADDON_COMMERCE,
  ...TUI_BELARUSIAN_LANGUAGE_ADDON_TABLE,
  ...TUI_BELARUSIAN_LANGUAGE_ADDON_EDITOR,
  ...TUI_BELARUSIAN_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_BELARUSIAN_LANGUAGE, TUI_BELARUSIAN_LANGUAGE_ADDON_COMMERCE, TUI_BELARUSIAN_LANGUAGE_ADDON_EDITOR, TUI_BELARUSIAN_LANGUAGE_ADDON_TABLE, TUI_BELARUSIAN_LANGUAGE_CORE, TUI_BELARUSIAN_LANGUAGE_COUNTRIES, TUI_BELARUSIAN_LANGUAGE_KIT, TUI_BELARUSIAN_LANGUAGE_LAYOUT };
